import React from 'react'
import './Pricingplans.css'
import tick from '../../Images/Vector (22).png'
import phone from '../../Images/Group.png';
import cross from '../../Images/fi_18396607.png'
import { openCallAppLink, openWhatsAppLink } from '../../Component/OpenWhatsApp';
const QuarterlyComparePlan = () => {
  return (
    <>
     <section className='compare_plans_section'>
     <h1 className='compare_plans_head'>Compare Your Plan</h1>
     <div className='compare_plan_div_wrapper'>
        <div className='left_compare_div' style={{
            marginTop:"26px"
        }}>
            <ul className='list_ul'>
                <li className='list_dark' style={{
                    marginBottom:"10px"
                }}>Service Type</li>
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    rowGap:'24px'
                }}>
                <li className='list_light '>Instant Property Survey Assistance</li>
                <li className='list_light mt-0'>Your In-Hand Properties Support</li>
                <li className='list_light mt-0'>Client-Centric Work Facilities	</li>
                <li className='list_light mt-0'>100% Verified Owner’s Listings</li>
                <li className='list_light mt-0'>Real-Time Weekly Updates</li>
                <li className='list_light mt-0'>Exclusive U/C & Ready Properties</li>
                <li className='list_light mt-0'>High-Quality Data with Images</li>
                <li className='list_light mt-0'>Direct Owner & Seller Contacts	</li>
                <li className='list_light mt-0'>No Middlemen, No Brokers</li>
               
                </div>
             
            </ul>
        </div>


        
        <div className='right_compare_div'>
            <div className='compare_div'>
                <div className='compare_inside_plan_head'>
                    <p className='compare_plan_para'>Starter</p>
                    <p className='compare_plan_price_para'>&#8377; 9,000</p>
                    <button
                    onClick={(e) => openWhatsAppLink(e, "919876543210", "I am interested in Quaterly Starter plan")}
                    className='get_started_btn'>Get Started Free</button>
                </div>
                <div className='tick_div'>
                {[1,2,3].map((e,i)=>{
                    return(
                        <>
                        <img key={i} src={cross} style={{
                        width:'18px',
                        height:'18px',
                    }}/>   
                        </>
                    )
                })}
                {[1,2,3,4,5,6].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={tick} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                    
                </div>
               
            </div>
            <div className='compare_div' id='compare_div_display_none'>
            <div className='compare_inside_plan_head'>
                    <p className='compare_plan_para'>Growth Plan</p>
                    <p className='compare_plan_price_para'>&#8377;8,000</p>
                    <button
                    onClick={(e) => openWhatsAppLink(e, "919876543210", "I am interested in Quaterly Growth Plan")}
                    className='get_started_btn'>Choose Plan</button>
                </div>

                <div className='tick_div'>
                {[1,2,].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={tick} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                {[1,].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={cross} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                {[1,2,3,4,5,6].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={tick} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                    
                </div>
               
            </div>
            <div className='compare_div' id='compare_div_display_none_two'>
            <div className='compare_inside_plan_head'>
                    <p className='compare_plan_para'>Premium Plan</p>
                    <p className='compare_plan_price_para'>&#8377;8,000</p>
                    <button
                    onClick={(e) => openWhatsAppLink(e, "919876543210", "I am interested in Quaterly Premium Plan")}
                    className='get_started_btn'>Choose Plan</button>
                </div>
                <div className='tick_div'>
                {[1,2,3,4,5,6,7,8,9].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={tick} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                    
                </div>
                
            </div>
        </div>
     </div>


<div id='left_1'>
<div className='compare_plan_div_wrapper'>
        <div className='left_compare_div' style={{
            marginTop:"26px"
        }}>
            <ul className='list_ul'>
                <li className='list_dark' style={{
                    marginBottom:"10px"
                }}>Service Type</li>
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    rowGap:'24px'
                }}>
                <li className='list_light '>Instant Property Survey Assistance</li>
                <li className='list_light mt-0'>Your In-Hand Properties Support</li>
                <li className='list_light mt-0'>Client-Centric Work Facilities	</li>
                <li className='list_light mt-0'>100% Verified Owner’s Listings</li>
                <li className='list_light mt-0'>Real-Time Weekly Updates</li>
                <li className='list_light mt-0'>Exclusive U/C & Ready Properties</li>
                <li className='list_light mt-0'>High-Quality Data with Images</li>
                <li className='list_light mt-0'>Direct Owner & Seller Contacts	</li>
                <li className='list_light mt-0'>No Middlemen, No Brokers</li>
               
                </div>
             
            </ul>
        </div>


        
        <div className='right_compare_div'>
            <div className='compare_div' id='compare_div_display_none_three'>
                <div className='compare_inside_plan_head'>
                    <p className='compare_plan_para'>Starter</p>
                    <p className='compare_plan_price_para'>&#8377; 9,000</p>
                    <button className='get_started_btn'>Get Started Free</button>
                </div>
                <div className='tick_div'>
                {[1,2,3].map((e,i)=>{
                    return(
                        <>
                        <img key={i} src={cross} style={{
                        width:'18px',
                        height:'18px',
                    }}/>   
                        </>
                    )
                })}
                {[1,2,3,4,5,6].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={tick} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                    
                </div>
               
            </div>
            <div className='compare_div'>
            <div className='compare_inside_plan_head'>
                    <p className='compare_plan_para'>Growth Plan</p>
                    <p className='compare_plan_price_para'>&#8377;8,000</p>
                    <button className='get_started_btn'>Choose Plan</button>
                </div>

                <div className='tick_div'>
                {[1,2,].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={tick} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                {[1,].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={cross} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                {[1,2,3,4,5,6].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={tick} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                    
                </div>
               
            </div>
            <div className='compare_div' id='compare_div_display_none_four'>
            <div className='compare_inside_plan_head'>
                    <p className='compare_plan_para'>Premium Plan</p>
                    <p className='compare_plan_price_para'>&#8377;8,000</p>
                    <button className='get_started_btn'>Choose Plan</button>
                </div>
                <div className='tick_div'>
                {[1,2,3,4,5,6,7,8,9].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={tick} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                    
                </div>
                
            </div>
        </div>
     </div>
</div>




<div id='left_2'>
<div className='compare_plan_div_wrapper'>
        <div className='left_compare_div' style={{
            marginTop:"26px"
        }}>
            <ul className='list_ul'>
                <li className='list_dark' style={{
                    marginBottom:"10px"
                }}>Service Type</li>
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    rowGap:'24px'
                }}>
                <li className='list_light '>Instant Property Survey Assistance</li>
                <li className='list_light mt-0'>Your In-Hand Properties Support</li>
                <li className='list_light mt-0'>Client-Centric Work Facilities	</li>
                <li className='list_light mt-0'>100% Verified Owner’s Listings</li>
                <li className='list_light mt-0'>Real-Time Weekly Updates</li>
                <li className='list_light mt-0'>Exclusive U/C & Ready Properties</li>
                <li className='list_light mt-0'>High-Quality Data with Images</li>
                <li className='list_light mt-0'>Direct Owner & Seller Contacts	</li>
                <li className='list_light mt-0'>No Middlemen, No Brokers</li>
               
                </div>
             
            </ul>
        </div>


        
        <div className='right_compare_div'>
            <div className='compare_div' id='compare_div_display_none_five'>
                <div className='compare_inside_plan_head'>
                    <p className='compare_plan_para'>Starter</p>
                    <p className='compare_plan_price_para'>&#8377; 9,000</p>
                    <button className='get_started_btn'>Get Started Free</button>
                </div>
                <div className='tick_div'>
                {[1,2,3].map((e,i)=>{
                    return(
                        <>
                        <img key={i} src={cross} style={{
                        width:'18px',
                        height:'18px',
                    }}/>   
                        </>
                    )
                })}
                {[1,2,3,4,5,6].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={tick} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                    
                </div>
               
            </div>
            <div className='compare_div' id='compare_div_display_none_six'>
            <div className='compare_inside_plan_head'>
                    <p className='compare_plan_para'>Growth Plan</p>
                    <p className='compare_plan_price_para'>&#8377;8,000</p>
                    <button className='get_started_btn'>Choose Plan</button>
                </div>

                <div className='tick_div'>
                {[1,2,].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={tick} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                {[1,].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={cross} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                {[1,2,3,4,5,6].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={tick} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                    
                </div>
               
            </div>
            <div className='compare_div' >
            <div className='compare_inside_plan_head'>
                    <p className='compare_plan_para'>Premium Plan</p>
                    <p className='compare_plan_price_para'>&#8377;8,000</p>
                    <button className='get_started_btn'>Choose Plan</button>
                </div>
                <div className='tick_div'>
                {[1,2,3,4,5,6,7,8,9].map((e,i)=>{
                    return (
                        <>
                        <img key={i} src={tick} style={{
                        width:'18px',
                        height:'18px',
                    }}/>
                        </>
                    )
                })}
                    
                </div>
                
            </div>
        </div>
     </div>
</div>




     <div className='d-flex justify-content-center' style={{
        marginTop:'40px'
     }}>
        <button
        onClick={(e) => openCallAppLink(e, "919876543210")}
        className='call_us_btn'>
        <img src={phone} style={{
            width:'15px'
        }}/>
        Call Us For More Details</button>
     </div>
     </section> 
    </>
  )
}

export default QuarterlyComparePlan 
